// Blog Single RTE

const PROPERTIES_TO_REMOVE = [
  "line-height",
  "margin-top",
  "border-color",
  "border-width",
  "padding",
  "vertical-align",
  "border-style",
  "margin-bottom",
];

const HEADER_OFFSET = 104;
let tocAbort = null;

function removeCSSProperties(element, propertiesToRemove) {
  const elementStyle = element.getAttribute("style");
  if (!elementStyle) {
    return;
  }

  const styleObj = {};
  elementStyle.split(";").forEach((pair) => {
    if (!pair.trim()) {
      return;
    }
    const [property, value] = pair.split(":").map((s) => s.trim());
    if (property && value && !propertiesToRemove.includes(property)) {
      styleObj[property] = value;
    }
  });

  const newStyleString = Object.entries(styleObj)
    .map(([prop, val]) => `${prop}: ${val}`)
    .join("; ");

  if (newStyleString) {
    element.setAttribute("style", newStyleString);
  } else {
    element.removeAttribute("style");
  }
}

function cleanBlogDetailStyles() {
  document.querySelectorAll(".blog-detail-container").forEach((element) => {
    removeCSSProperties(element, PROPERTIES_TO_REMOVE);
    element.querySelectorAll("*").forEach((childElement) => {
      removeCSSProperties(childElement, PROPERTIES_TO_REMOVE);
    });
  });
}

function scrollToElement(element) {
  if (!element) {
    return;
  }

  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - HEADER_OFFSET;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });
}

function resolveTocTarget(href) {
  if (!href || !href.startsWith("#")) {
    return null;
  }

  return document.getElementById(href.slice(1));
}

function getHeadingAnchorId(heading, index) {
  // Prefer a unique heading id. Do NOT reuse the content-element frame id
  // (e.g. c23175): blog RTE often has many h2s in one frame, and sharing
  // that id collapses the TOC down to a single entry.
  if (heading.id && !/^c\d+$/.test(heading.id)) {
    return heading.id;
  }

  heading.id = `heading-${index}`;
  return heading.id;
}

function isMeaningfulHeadingText(text) {
  // Ignore empty / punctuation-only headings (e.g. comments plugin ":" fallback)
  return /[\p{L}\p{N}]/u.test(text);
}

function collectPageHeadings(contentDiv) {
  const tocRoot = contentDiv.querySelector(".table-of-content");
  const seenAnchorIds = new Set();

  return Array.from(contentDiv.querySelectorAll("h2"))
    .filter((heading) => !tocRoot?.contains(heading))
    .map((heading, index) => ({
      id: getHeadingAnchorId(heading, index),
      textContent: heading.textContent.trim(),
      element: heading,
    }))
    .filter((heading) => {
      if (
        !heading.textContent ||
        !isMeaningfulHeadingText(heading.textContent) ||
        seenAnchorIds.has(heading.id)
      ) {
        return false;
      }

      seenAnchorIds.add(heading.id);
      return true;
    });
}

function createTocElement(headings) {
  const tocList = document.querySelector(
    ".table-of-content .accordion-item .accordion-body nav ol"
  );

  if (!tocList) {
    return null;
  }

  tocList.innerHTML = "";

  headings.forEach((heading) => {
    const listItem = document.createElement("li");
    const link = document.createElement("a");
    link.textContent = heading.textContent;
    link.href = `#${heading.id}`;
    listItem.appendChild(link);
    tocList.appendChild(listItem);
  });

  return tocList;
}

function bindTocLinks() {
  const tocList = document.querySelector(
    ".table-of-content .accordion-item .accordion-body nav ol"
  );

  if (!tocList) {
    return;
  }

  if (tocAbort) {
    tocAbort.abort();
  }
  tocAbort = new AbortController();
  const { signal } = tocAbort;

  tocList.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener(
      "click",
      (event) => {
        const href = link.getAttribute("href");
        if (!href || href === "#") {
          return;
        }

        const target = resolveTocTarget(href);
        if (!target) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        scrollToElement(target);
      },
      { signal }
    );
  });
}

function generateTableOfContents() {
  const contentDiv = document.querySelector(".blog-detail-container");
  const tocDiv = document.querySelector(".table-of-content");

  if (!contentDiv || !tocDiv) {
    return;
  }

  const tocList = document.querySelector(
    ".table-of-content .accordion-item .accordion-body nav ol"
  );
  if (!tocList) {
    return;
  }

  const headings = collectPageHeadings(contentDiv);
  if (headings.length === 0) {
    return;
  }

  createTocElement(headings);
  bindTocLinks();
  tocDiv.classList.add("active");
}

export const initSingleBlog = () => {
  if (!document.querySelector(".blog-detail-container")) {
    return;
  }

  cleanBlogDetailStyles();
  generateTableOfContents();
};

if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    () => {
      setTimeout(initSingleBlog, 100);
    },
    { once: true }
  );
} else {
  setTimeout(initSingleBlog, 100);
}
